// src/graphql/queries/teamQueries.js

export const getAdminTeamInfo = () => `query GetAdminTeamInfo($companyId: String!) {
    adminTeamInfo(companyId: $companyId) {
        members {
            id
            email
            firstName
            lastName
            role
            jobTitle
            active
            lastLogin
            isCompanyRepresentative
            createdAt
        }
        memberCount
        maxUsers
        canAddUsers
        pendingInvitations {
            id
            inviteeEmail
            type
            status
            role
            message
            expiresAt
            createdAt
            inviter {
                id
                firstName
                lastName
                email
            }
        }
        pendingReferrals {
            id
            inviteeEmail
            firstName
            lastName
            type
            status
            message
            expiresAt
            createdAt
        }
    }
}`;

export const getAdminTeamInvitations = () => `query GetAdminTeamInvitations($companyId: String!, $status: [InvitationStatus!]) {
    adminTeamInvitations(companyId: $companyId, status: $status) {
        id
        companyId
        inviteeEmail
        type
        status
        role
        message
        expiresAt
        createdAt
        company {
            id
            name
        }
        inviter {
            id
            firstName
            lastName
            email
        }
    }
}`;

export const validateInvitationToken = () => `query ValidateInvitationToken($token: String!) {
    validateInvitationToken(token: $token) {
        valid
        companyName
        inviterName
        type
        requiresAccount
    }
}`;
